import { render } from "./PanelAdminImport.vue?vue&type=template&id=4e1006e3&ts=true"
import script from "./PanelAdminImport.vue?vue&type=script&lang=ts"
export * from "./PanelAdminImport.vue?vue&type=script&lang=ts"

import "./PanelAdminImport.vue?vue&type=style&index=0&id=4e1006e3&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__